import { render } from "./Counter.vue?vue&type=template&id=67d29362&scoped=true"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=67d29362&scoped=true&lang=css"

import exportComponent from "/Users/sebi/www/screen-app/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d29362"]])

export default __exports__